<template>
  <div :id="brainsDataListId" class="brains-data-list-container">
    <div class="brains-data-list--headers-container" :class="{ 'brains-data-list--headers-container__two-cols' : !activeVariation }">
      <div class="brains-data-list--title" v-html="title" />
      <div class="brains-data-list--value" />
      <div v-if="checkVarInTable('qoq')" class="brains-data-list--qoq" v-html="qoqTitleComputed" />
      <div v-if="checkVarInTable('yoy')" class="brains-data-list--yoy" v-html="yoyTitleComputed" />
    </div>

    <div class="brains-data-list--content">
      <dataRowEvolVar v-for="(item, key) in parsedData" :key="key" :fs-size="fsSize" :active-variation="activeVariation" :class="{ 'data-list--row__two-cols' : !activeVariation }">
        <div slot="col-title">
          <tooltipDataAside v-if="tooltipsActive" :button="false" class="popover-tooltip-info" :time="2" activator="mouseover" position="left" :border="true">
            <template
              v-slot:popoverName
            ><span class="brains-tooltip-style"><font-awesome-icon icon="info" /></span></template>
            <div class="data-list-tooltip-container">
              {{ item.fuente }}
            </div>
          </tooltipDataAside>
          <span class="ml-1 brains-data-list-export-cell">{{ getParsedLiteralName(item.dato) }}</span>
        </div>
        <div slot="col-value" class="brains-data-list-export-cell">{{ item.valor }}</div>
        <div v-if="activeVariation" slot="col-qoq" class="brains-data-list-export-cell">
          <span
            class="col-data-qoq-yoy-var"
            :class="[
              { 'col-data-qoq-yoy-var--evol-neutra': checkNeutralNum(item.valor_qoq) },
              { 'col-data-qoq-yoy-var--evol-negativa': !!item.valor_qoq && parseFloat(item.valor_qoq.replace(',', '.')) < 0 },
              { 'col-data-qoq-yoy-var--evol-positiva': !!item.valor_qoq && parseFloat(item.valor_qoq.replace(',', '.')) > 0 },
            ]"
          >
            <div v-if="getVarIcon(item.valor_qoq) === 'minus'" class="data-list-na-value">-</div>
            <font-awesome-icon v-else :icon="getVarIcon(item.valor_qoq)" />
            <span v-if="item.valor_qoq !== 'na'">{{ item.valor_qoq }}%</span>
          </span>
        </div>
        <div v-if="activeVariation" slot="col-yoy" class="brains-data-list-export-cell">
          <span
            class="col-data-qoq-yoy-var"
            :class="[
              { 'col-data-qoq-yoy-var--evol-neutra': checkNeutralNum(item.valor_yoy) },
              { 'col-data-qoq-yoy-var--evol-negativa': !!item.valor_yoy && parseFloat(item.valor_yoy.replace(',', '.')) < 0 },
              { 'col-data-qoq-yoy-var--evol-positiva': !!item.valor_yoy && parseFloat(item.valor_yoy.replace(',', '.')) > 0 },
            ]"
          >
            <div v-if="getVarIcon(item.valor_yoy) === 'minus'" class="data-list-na-value">-</div>
            <font-awesome-icon v-else :icon="getVarIcon(item.valor_yoy)" />
            <span v-if="item.valor_yoy !== 'na'">{{ item.valor_yoy }}%</span>
          </span>
        </div>
      </dataRowEvolVar>
    </div>
  </div>
</template>

<script>
import dataRowEvolVar from '@/components/designComponents/dataRowEvolVar'
import tooltipDataAside from '@/components/designComponents/tooltipDataAside'
export default {
  name: 'BrainsDataList',
  components: { tooltipDataAside, dataRowEvolVar },
  props: {
    namespaceKey: {
      type: String,
      default: ''
    },
    idData: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    qoqTitle: {
      type: String,
      default: ''
    },
    yoyTitle: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: null
    },
    exportVal: {
      type: Boolean,
      default: false
    },
    tooltipsActive: {
      type: Boolean,
      default: true
    },
    activeVariation: {
      type: Boolean,
      default: true
    },
    fsSize: {
      default: null
    }
  },
  data() {
    return {
      randomNum: 0
    }
  },
  computed: {
    countryLevel: {
      get() {
        return this.$store.state['location'].geolevels.filter((item) => item.level === 0)[0].id
      }
    },
    brainsDataListId() {
      return 'brains-data-list-' + this.randomNum
    },
    overflow() {
      if (this.clientWidth < this.scrollWidth) {
        return true
      } else {
        return false
      }
    },
    parsedData() {
      // var object = ''

      // if (this.exportVal) {
      //   object = this.data.attributes
      // } else {
      //   object = this.data.feature.attributes
      // }

      // var parsedObj = {}
      // for (var key in object) {
      //   if (key !== 'Shape' && key !== 'title' && key !== 'objectid') {
      //     var arr = object[key].split(' // ')[0].split(' | ')
      //     var arr2 = object[key].split(' // ')[1].split(' | ')
      //     parsedObj[key] = { data: arr, info: arr2 }
      //   }
      // }
      return this.data ?? []
    },
    qoqTitleComputed() {
      switch (this.id) {
        case 'Population': return this.$t('yoy-var')
        case 'Socioeconomics': return this.$t('yoy-var')
        case 'Economy': return this.$t('yoy-var')
        case 'AnnualUnemployment': return this.$t('yoy-var')
        case 'Dwellings': return this.$t('yoy-var')
        default: return this.qoqTitle
      }
    },
    yoyTitleComputed() {
      switch (this.id) {
        case 'Population': return this.$t('3year-var')
        case 'Socioeconomics': return this.$t('3year-var')
        case 'Economy': return this.$t('3year-var')
        case 'AnnualUnemployment': return this.$t('3year-var')
        case 'Dwellings': return this.$t('3year-var')
        default: return this.yoyTitle
      }
    }
  },
  created() {
    this.generateRandomNum()
  },
  methods: {
    getParsedLiteralName(name) {
      if (name === null || name === undefined) { return '' }

      name = name.toLowerCase()
      if (name === 'trans_em2' && this.countryLevel === 57363) { return this.$t('dataSection.trans_em2OMI') }
      if (name === 'trans_precio' && this.countryLevel === 57363) { return this.$t('dataSection.trans_precioOMI') }
      if (name === 'trans_sup' && this.countryLevel === 57363) { return this.$t('dataSection.trans_em2OMI') }

      return this.$t('dataSection.' + name)
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    checkNeutralNum(num) {
      if (num === undefined || num === null || num === 'na' || parseFloat(num.replace(',', '.')) === 0) { return true }
      return false
    },
    checkVarInTable(type) {
      // for (var key in data) {
      //   if (data[key].data.length > 1) { return true }
      // }
      if (type === 'yoy') { return this.parsedData.filter(item => item.valor_yoy !== null && item.valor_yoy !== 'na').length > 0 }
      return this.parsedData.filter(item => item.valor_qoq !== null && item.valor_qoq !== 'na').length > 0
    },
    getVarIcon(value, inverso = false) {
      if (value === 'na' || value === null || value === undefined) {
        return 'minus'
      }
      value = parseFloat(value.replace(',', '.'))
      if (value === 0) {
        return 'equals'
      }
      if ((value >= 0 && !inverso) || (value < 0 && inverso)) {
        return 'arrow-up'
      }
      if ((value < 0 && !inverso) || (value >= 0 && inverso)) {
        return 'arrow-down'
      }
      return 'minus'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
$evolPositiva: rgb(91, 205, 55);
$evolNegativa: rgb(249, 65, 51);
$evolNeutra: rgb(194, 194, 194);

.data-list-na-value {
  color: black;
}

.col-data-qoq-yoy-var {
  display: flex;
  justify-content: center;
  align-items: center;

  &--evol-positiva {
    color: $evolPositiva;
  }

  &--evol-negativa {
    color: $evolNegativa;
  }

  &--evol-neutra {
    color: $evolNeutra;
  }

  svg {
    font-size: 18px;
    margin-right: 6px;
  }
}

.brains-data-list-container {
  width: 100%;

  .brains-data-list--headers-container {
    width: 100%;
    display: grid;
    justify-content: space-between;
    align-items: center;
    grid-template-columns: 45% 30% 12.5% 12.5%;
    border-bottom: 2px solid $primary-brains;

    &__two-cols {
      grid-template-columns: 75% 25% !important;
    }
  }

  .brains-data-list--title {
    font-size: 15px;
    font-family: "Montserrat-SemiBold",sans-serif;
    padding-left: 15px;
    margin-bottom: 5px;
  }

  .brains-data-list--qoq,
  .brains-data-list--yoy {
    font-size: 15px;
    font-family: "Montserrat-Light",sans-serif;
    color: rgb(194, 194, 194);
    padding-left: 5px;
    margin-bottom: 5px;
  }
}

.data-list--row__two-cols {
  grid-template-columns: 75% 25% !important;
}
</style>
